import React from 'react';
import { Switch } from '@headlessui/react';
import { functionNoop } from 'src/utils/function/noop';
import classNames from 'classnames';

interface Props {
  checked: boolean;
  disabled?: boolean;
  groupClassName?: string;
  labelClassName?: string;
  className?: string;
  label?: string;
  labelType?: 'regular' | 'strong' | 'heading';
  onChange?: (value: boolean) => void;
}

export const ToggleComponent = ({
  checked = false,
  onChange = functionNoop,
  label,
  disabled,
  groupClassName,
  labelClassName,
  labelType = 'regular',
  className,
}: Props) => {
  const labelClass =
    labelType === 'heading'
      ? 'heading-bedrock-tertiary'
      : labelType === 'strong'
      ? 'text-bedrock-p-strong'
      : 'text-bedrock-p';

  return (
    <Switch.Group>
      <div
        className={classNames(
          'flex items-center justify-between space-x-4 has-hover transform duration-200 ease-in-out',
          disabled && 'pointer-events-none',
          groupClassName
        )}
      >
        {label && (
          <Switch.Label
            className={classNames('text-bedrock-black select-none cursor-pointer w-full', labelClass, labelClassName)}
          >
            {label}
          </Switch.Label>
        )}
        <Switch
          checked={checked}
          onChange={onChange}
          className={classNames(
            'relative inline-flex w-8 h-4 items-center rounded-full focus:outline-none shrink-0',
            checked ? 'bg-bedrock-black' : 'bg-bedrock-gray-medium',
            disabled && 'opacity-40',
            className
          )}
        >
          <span className='sr-only'>Enable notifications</span>
          <span
            className={classNames(
              'bg-white w-3 h-3 inline-block rounded-full transform duration-200 ease-in-out',
              checked ? 'translate-x-[18px]' : 'translate-x-[2px]'
            )}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
};
